import React, { useEffect, useRef, useState } from 'react';
import defaultClasses from './row.module.css';
import { verticalAlignmentToFlex } from '../../utils';
import { useStyle } from '../../classify';
import resourceUrl from '../../makeUrl';
import { useDetectScrollWidth } from '../../useDetectScrollWidth';
import { useMediaQuery } from '../../useMediaQuery';

const { matchMedia } = globalThis;

const Row = props => {
    const backgroundElement = useRef(null);
    const [bgImageStyle, setBgImageStyle] = useState(null);
    const classes = useStyle(defaultClasses, props.classes);

    const {
        appearance,
        verticalAlignment,
        minHeight,
        backgroundColor,
        desktopImage,
        mobileImage,
        backgroundSize,
        backgroundPosition,
        backgroundAttachment,
        backgroundRepeat,
        textAlign,
        border,
        borderColor,
        borderWidth,
        borderRadius,
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        mediaQueries,
        paddingTop,
        paddingRight,
        paddingBottom,
        paddingLeft,
        children,
        cssClasses = [],
        videoOverlayColor
    } = props;

    const { styles: mediaQueryStyles } = useMediaQuery({ mediaQueries });

    let image = desktopImage;
    if (mobileImage && matchMedia && matchMedia('(max-width: 768px)').matches) {
        image = mobileImage;
    }

    const dynamicStyles = {
        minHeight,
        backgroundColor,
        textAlign,
        border,
        borderColor,
        borderWidth,
        borderRadius,
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        paddingTop,
        paddingRight,
        paddingBottom,
        paddingLeft
    };

    const videoOverlayStyles = {
        backgroundColor: videoOverlayColor
    };

    if (image) {
        dynamicStyles.backgroundImage = bgImageStyle;
        dynamicStyles.backgroundSize = backgroundSize;
        dynamicStyles.backgroundPosition = backgroundPosition;
        dynamicStyles.backgroundAttachment = backgroundAttachment;
        dynamicStyles.backgroundRepeat = backgroundRepeat;
    }

    if (verticalAlignment) {
        dynamicStyles.display = 'flex';
        dynamicStyles.justifyContent = verticalAlignmentToFlex(
            verticalAlignment
        );
        dynamicStyles.flexDirection = 'column';
    }

    useDetectScrollWidth();
    // Determine the containers width and optimize the image
    useEffect(() => {
        // Intelligently resize cover background images
        if (image && backgroundElement.current) {
            if (backgroundSize === 'cover') {
                let elementWidth = backgroundElement.current.offsetWidth;
                let elementHeight = backgroundElement.current.offsetHeight;
                setBgImageStyle(
                    `url(${resourceUrl(image, {
                        type: 'image-wysiwyg',
                        width: elementWidth,
                        height: elementHeight,
                        quality: 85,
                        crop: false,
                        fit: 'cover'
                    })})`
                );
            } else {
                setBgImageStyle(
                    `url(${resourceUrl(image, {
                        type: 'image-wysiwyg',
                        quality: 85
                    })})`
                );
            }
        }
    }, [backgroundSize, image, setBgImageStyle]);

    const videoOverlay = videoOverlayColor ? (
        <div className={classes.videoOverlay} style={videoOverlayStyles} />
    ) : null;

    if (cssClasses?.includes('category-tiles')) {
        const backgroundColor = children?.[0]?.props?.data?.children?.[0].backgroundColor;
        document.documentElement.style.setProperty('--category-tile-background-color', backgroundColor);
    }

    if (appearance === 'full-bleed') {
        return (
            <div
                ref={backgroundElement}
                style={{
                    ...dynamicStyles,
                    ...mediaQueryStyles,
                    marginLeft: null,
                    marginRight: null,
                    '--pbRowMarginLeft': marginLeft,
                    '--pbRowMarginRight': marginRight
                }}
                className={[
                    classes.fullBleed,
                    classes.root,
                    ...cssClasses
                ].join(' ')}
            >
                {videoOverlay}
                {children}
            </div>
        );
    }

    if (appearance === 'full-width') {
        return (
            <div
                ref={backgroundElement}
                style={{
                    ...dynamicStyles,
                    ...mediaQueryStyles,
                    marginLeft: null,
                    marginRight: null,
                    '--pbRowMarginLeft': marginLeft,
                    '--pbRowMarginRight': marginRight
                }}
                className={[
                    classes.fullBleed,
                    classes.root,
                    ...cssClasses
                ].join(' ')}
            >
                {videoOverlay}
                <div className={classes.contained}>{children}</div>
            </div>
        );
    }

    return (
        <div className={[classes.contained, ...cssClasses].join(' ')}>
            <div
                ref={backgroundElement}
                style={{ ...dynamicStyles, ...mediaQueryStyles }}
            >
                {videoOverlay}
                {children}
            </div>
        </div>
    );
};

export default Row;
